import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ShowcaseLoyaltyTierStateDto
*  Текущий tier; null, если ещё не рассчитан.
*/
export class ShowcaseLoyaltyTierStateDto extends ActiveModel {

  /**
  * currentTierOrder
  *   */
  @ActiveField(0)
  currentTierOrder: number = 0


/**
  * currentTierName
  * 
  */
  @ActiveField()
  currentTierName?: null | string


  /**
  * turnoverInPeriod
  *   */
  @ActiveField(0)
  turnoverInPeriod: number = 0


/**
  * periodStartedAt
  * 
  */
  @ActiveField('')
  periodStartedAt: string = ''


/**
  * periodEndsAt
  * 
  */
  @ActiveField('')
  periodEndsAt: string = ''


/**
  * calculatedAt
  * 
  */
  @ActiveField('')
  calculatedAt: string = ''


/**
  * nextTierName
  * 
  */
  @ActiveField()
  nextTierName?: null | string


  /**
  * nextTierMinTurnover
  *   */
  @ActiveField()
  nextTierMinTurnover?: null | number


  /**
  * progressToNextTierPercent
  * Прогресс к следующему уровню, 0–100.  */
  @ActiveField()
  progressToNextTierPercent?: null | number
}
